import type { SheetScale } from '@otto/onscreen-engine';
import { COLORS, mono } from './styles.ts';

interface Props {
  scale: SheetScale | null;
}

export function ScaleReadout({ scale }: Props) {
  if (!scale) {
    return <div style={{ fontSize: 12, color: COLORS.textDim }}>Not set.</div>;
  }
  return (
    <div style={{ display: 'flex', flexDirection: 'column', gap: 4 }}>
      <MetaRow label="PX/FT" value={scale.pixelsPerFoot.toFixed(3)} />
      <MetaRow label="DPI" value={scale.dpi.toString()} />
      <MetaRow label="SOURCE" value={scale.source} />
      {scale.scaleString && <MetaRow label="STRING" value={scale.scaleString} />}
    </div>
  );
}

function MetaRow({ label, value }: { label: string; value: string }) {
  return (
    <div
      style={{
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'baseline',
        marginBottom: 6,
      }}
    >
      <span style={mono(10, COLORS.textDim)}>{label}</span>
      <span style={mono(12, COLORS.textMuted)}>{value}</span>
    </div>
  );
}
